import { createSvg } from '@r1-frontend/ui-react/components/svg/createSvg';

const VideoVertical = ({ strokeWidth = 1.5 }) => <g id={'contour'}>
    <path
        d='M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z'
        stroke='#181B21'
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
    />
    <path d='M6.89001 2.52002V21.48' strokeWidth={strokeWidth} strokeLinecap='round' strokeLinejoin='round'/>
    <path d='M16.89 2.52002V21.48' strokeWidth={strokeWidth} strokeLinecap='round' strokeLinejoin='round'/>
    <path d='M6.89004 6.96997H2.54004' strokeWidth={strokeWidth} strokeLinecap='round' strokeLinejoin='round'/>
    <path d='M6.89003 12H2.03003' strokeWidth={strokeWidth} strokeLinecap='round' strokeLinejoin='round'/>
    <path d='M6.88998 16.97H2.47998' strokeWidth={strokeWidth} strokeLinecap='round' strokeLinejoin='round'/>
    <path d='M21.89 6.96997H17.54' strokeWidth={strokeWidth} strokeLinecap='round' strokeLinejoin='round'/>
    <path d='M21.89 12H17.03' strokeWidth={strokeWidth} strokeLinecap='round' strokeLinejoin='round'/>
    <path d='M16.97 12H5.96997' strokeWidth={strokeWidth} strokeLinecap='round' strokeLinejoin='round'/>
    <path d='M21.89 16.97H17.48' strokeWidth={strokeWidth} strokeLinecap='round' strokeLinejoin='round'/>
</g>;

export default createSvg(
    VideoVertical,
    'video-vertical',
);
